<template>
  <div id="create_password_form" class="form-bg">
    <div class="title font-main-bold">{{ lbl.register.create_new_password }}</div>
    <div>
        <InputPassword
            v-model="form.password"
            inputId="reset-password"
            :inputLbl="lbl.register.password"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :inputMaxLength="15"
            :inputMinLength="8"
            :errorInfo="errorInfo[0]"
        ></InputPassword>
    </div>
    <div>
        <InputPassword
            v-model="form.confirmpassword"
            inputId="reset-new-password"
            :inputLbl="lbl.register.confirmPassword"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="true"
            :inputMaxLength="15"
            :inputMinLength="8"
            :errorInfo="errorInfo[1]"
        ></InputPassword>
    </div>
    <div class="pt-4 pb-2 ">
        <div class="mx-auto text-center">
            <OrangeButton @onClick="onClickSubmit()">
                <div class="font-main">{{ lbl.default.confirm }}</div>
            </OrangeButton>
        </div>
    </div>
  </div>
</template>

<script>
import InputPassword from '@/components/Input/Password.vue';
import OrangeButton from '@/components/Button/OrangeButton.vue';
import LocaleMixin from '@/mixin/LocaleMixin';
import FormHelper from '@/helper/FormHelper';
export default {
    components:{
        OrangeButton,
        InputPassword
    },
    props:{
        modalController: Object
    },
    mixins: [LocaleMixin],
    data: function(){
        return {
            form: {
                password:'',
                confirmpassword: ''
            },
            isFirstSave: true,
            errorInfo: []
        }
    },
    created: function(){
        this.errorInfo = FormHelper.genErrorInfo(2);
    },
    methods:{
        onClickSubmit:function(){
            this.isFirstSave = false
            let isValid = FormHelper.validate(this.errorInfo);
            if(isValid && this.checkPasswordNotMatch()){
                this.$emit('submit', this.form);
            }
        },
        checkPasswordNotMatch: function(){
            if(this.form.password == this.form.confirmpassword){
                return true;
            }else{
                this.modalController.alertModal
                                    .setMsg(this.lbl.register.password_not_match)
                                    .show();
                return false;
            }
        },
    }

}
</script>
<style lang="scss">
 @import "@/style/base/base.scss";
#create_password_form
{
    .wrap-input{
        .input-box {
            .input-field{
                color: $a-black-333333;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
@import '../../../style/base/base.scss';
.form-bg{
    max-width: 445px;
    flex-grow: 0;
    margin: auto;
    padding: 20px 30px 20px 30px;
    border-radius: 20px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.25);
    background-color: #fff;
}
.title{
    text-align: center;
    color: $a-black-333333;
    font-size: 16px;

    @include min-desktop {
        font-size: 18px;
    }
}
</style>
